module.exports = __webpack_public_path__ + "components/roadsurfer/static/roadsurfer-1920@2x-7cf3640375b235217732be06c354a2d4.webp";